export default "__VITE_ASSET__s5ocEMW6__"